module.exports = __webpack_public_path__ + "static/media/wrl-daytona-logo@2x.2aa887e4.png";


//////////////////
// WEBPACK FOOTER
// ./html/assets/images/wrl-daytona-logo@2x.png
// module id = 1214
// module chunks = 0